import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { MergeableTrip } from '@pages/trips-page/components/merge-trip-tab/interfaces';

@Component({
  selector: 'app-merging-details',
  templateUrl: './merging-details.component.html',
  styleUrls: ['./merging-details.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MergingDetailsComponent {
  allTrips = input<MergeableTrip[]>();
  selectedTripIds = input<number[]>();
  distance = input<number>();
  isTripMerged = input<boolean>();

  startInfo = signal<MergeableTrip | undefined>(undefined);
  endInfo = signal<MergeableTrip | undefined>(undefined);

  constructor() {
    effect(() => {
      const selectedTripIds = this.selectedTripIds();
      this.setStartAndEndDetails(selectedTripIds || []);
    });
  }

  private setStartAndEndDetails(selectedTripIds: number[]): void {
    const allTrips = this.allTrips();
    this.startInfo.set(
      allTrips?.find(trip => trip.TripID === selectedTripIds[0])
    );
    this.endInfo.set(
      allTrips?.find(
        trip => trip.TripID === selectedTripIds[selectedTripIds.length - 1]
      )
    );
  }
}
